import { Place } from './container.styled';

function Container(props: any) {
  return <Place className="container">{props.children}</Place>;
}

export default Container;
